/**
 * Utilitários de documento (CNPJ/CPF) e normalização textual.
 *
 * Mantido isolado para permitir reuso entre páginas e testes unitários
 * sem dependências externas, seguindo o padrão já usado no CadastroEmpresa.
 */

const TAMANHO_CNPJ = 14;
const TAMANHO_CPF = 11;

export function normalizarDocumento(valor) {
  return String(valor || "").replace(/\D/g, "");
}

export function formatarCNPJ(digitos) {
  const soDigitos = String(digitos || "")
    .padStart(TAMANHO_CNPJ, "0")
    .slice(-TAMANHO_CNPJ);
  return soDigitos.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
    "$1.$2.$3/$4-$5",
  );
}

export function formatarCPF(digitos) {
  const soDigitos = String(digitos || "")
    .padStart(TAMANHO_CPF, "0")
    .slice(-TAMANHO_CPF);
  return soDigitos.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
}

export function formatarDocumento(digitos) {
  const limpo = normalizarDocumento(digitos);
  if (limpo.length === TAMANHO_CNPJ) return formatarCNPJ(limpo);
  if (limpo.length === TAMANHO_CPF) return formatarCPF(limpo);
  return limpo;
}

export { formatarCnpjCpf } from "../../../utils/formatters.js";

export function extrairDocumentoDaBusca(termo) {
  const texto = String(termo || "").trim();
  const match = texto.match(
    /([A-Z0-9]{2}\.?[A-Z0-9]{3}\.?[A-Z0-9]{3}\/?[A-Z0-9]{4}-?\d{2}|\d{11})/i,
  );
  if (match?.[0]) return match[0];
  return texto;
}

/** Normaliza string para comparação textual case-insensitive e sem acentos. */
export function normalizarTextoBusca(valor) {
  return String(valor || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

/** Normaliza um ID para comparação robusta. Aceita inteiros ou strings. */
export function normalizarIdComparacao(valor) {
  const texto = String(valor || "").trim();
  if (!texto) return "";
  if (/^\d+$/.test(texto)) return String(Number(texto));
  return texto.toLowerCase();
}
